<div  *ngIf="isExternalUser" class="box-padding-1 white-box">
  <mat-checkbox class="report-checkbox"
                (change)="onChangeToggle($event)"
                [checked]="reportFollowUp"
  >Save this report for later</mat-checkbox>
</div>
